import { useQuery } from "react-query";
import type { ApiError } from "@/react/config/CustomErrors";
import { reactQueryGet } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";

export const THEME_STATS_QUERY_KEY = "theme-stats";

export const getThemeStatsQueryKey = (themeId: number) => [
  THEME_STATS_QUERY_KEY,
  themeId,
];

interface ThemeStats {
  page_theme_usage: Array<{
    id: number;
    name: string;
    slug: string;
    status: string;
  }>;
  page_theme_usage_count: number;
  site_theme_usage_count: number;
  total_count: number;
}

export const useGetThemeStats = (themeId: number) =>
  useQuery<ThemeStats, ApiError>({
    queryKey: getThemeStatsQueryKey(themeId),
    queryFn: () =>
      reactQueryGet(internalApi.settings.sites.themes.show({ themeId })),
    enabled: !!themeId,
  });
